module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_EN.7cdc2aa3.jpg";